import clsx from 'clsx'
import { Skeleton } from '../../../components'
import React from 'react'
import listStyles from '../datedlist.module.scss'
import styles from './dated-list-skeleton.module.scss'
import PropTypes from 'prop-types'

const ListSkeleton = () => (
  <Skeleton shown className={styles['list-skeleton']}>
    <div className={styles['list-skeleton__heading']}>
      <div className={styles['list-skeleton__heading-date']} />
      <div className={styles['list-skeleton__heading-loader']} />
    </div>
    <ul
      className={clsx(
        styles['list-skeleton__list'],
        listStyles['dated-list__grid'],
      )}
    >
      {Array.apply(null, Array(5)).map((item, i) => (
        <li
          className={styles['list-skeleton__list-item']}
          key={'skeleton-li-' + i}
        >
          <div className={styles['list-skeleton__list-fig']} />
          <div className={styles['list-skeleton__list-summary']}>
            <div className={styles['list-skeleton__list-line']}>
              <div
                className={clsx(
                  styles['list-skeleton__list-text'],
                  styles['list-skeleton__list-text_type1'],
                )}
              />
              <div
                className={clsx(
                  styles['list-skeleton__list-text'],
                  styles['list-skeleton__list-text_type2'],
                )}
              />
            </div>
            <div className={styles['list-skeleton__list-line']}>
              <div
                className={clsx(
                  styles['list-skeleton__list-text'],
                  styles['list-skeleton__list-text_type3'],
                )}
              />
            </div>
          </div>
        </li>
      ))}
    </ul>
    <div className={styles['list-skeleton__footer']}>
      <div className={styles['list-skeleton__footer-load-more']} />
    </div>
  </Skeleton>
)

ListSkeleton.propTypes = {
  rowsLength: PropTypes.number,
}
export default ListSkeleton
